import { indexOf } from "@amcharts/amcharts4/.internal/core/utils/Array";
import React from "react";
import "./TopRightActionLinks.css";

const iconMap = {
  filter: "/img/table_blue.png",
  filter_active: "/img/table_blue_active.png",
  bulb: "/img/light_bulb.svg",
  bulb_active: "/img/light_bulb_active.png",
  chart: "/img/chart.png",
  chart_active: "/img/chart_active.png",
  conversation: "/img/ai_converation.png",
  conversation_active: "/img/ai_conversation_active.png",
  mindMap: "/img/mind_map.png",
  mindMap_active: "/img/mind_map_active.png",
  download: "/img/download.svg",
  download_active: "/img/download_active.png",
};

const TopRightActionLinks = ({
  actions = [],
  section_type = "table",
  activeTypes = [],
}) => {
  // const filteredActions = actions.filter((action) => action.type !== "chart");
  const filteredActions = actions;

  return (
    <div className={`${section_type}_subblock_right`}>
      {filteredActions.map((action, index) => {
        const isActive = activeTypes === action.type;
        const activeSuffix = isActive ? "_active" : "";
        const iconPath = iconMap[action.type.replace("_active", "")]
          ?.replace(".png", `${activeSuffix}.png`)
          .replace(".svg", `${activeSuffix}.svg`);

        return (
          <a
            key={index}
            href="#"
            className={`${section_type}_filter ${
              activeTypes.includes(action.type) ? "content_active" : ""
            }`}
            onClick={(e) => {
              e.preventDefault();
              if (typeof action.onClick === "function") {
                action.onClick();
              }
            }}
            title={action.title || ""}
          >
            <img
              src={
                activeTypes.includes(action.type)
                  ? iconMap[action.type + "_active"] || iconMap[action.type]
                  : iconMap[action.type]
              }
              alt={action.title || "icon"}
              className={`${section_type}_filter_icon`}
              width="16"
            />
          </a>
        );
      })}
    </div>
  );
};

export default TopRightActionLinks;
